import React from 'react';
import '../Skills/Skills.css';
import MiniDiv from './Mini-div/MiniDiv';



function Skills(){
  return (
    <div className='skills-div' id='tools'>
        <h3>My Tech Tools</h3>
        <div className='sub-div'>
            <MiniDiv imgsrc='./images/icons/html.png' title='HTML5'></MiniDiv>
            <MiniDiv imgsrc='./images/icons/css3.png' title='CSS3'></MiniDiv>
            <MiniDiv imgsrc='./images/icons/bootstrap.png' title='BOOTSTRAP'></MiniDiv>
            <MiniDiv imgsrc='./images/icons/tailwind.png' title='TAILWIND'></MiniDiv>
            <MiniDiv imgsrc='./images/icons/javascript.png' title='JAVASCRIPT'></MiniDiv>
            <MiniDiv imgsrc='./images/icons/react.png' title='REACT'></MiniDiv>
            <MiniDiv imgsrc='./images/icons/github-1.png' title='GITHUB'></MiniDiv>
        </div>
    </div>
  )
}



export default Skills;